import { DEFAULT_PIN_THEME_ID } from '../../defaults';
import { PinTheme } from '../../models';

export function isDefaultPinTheme(pinTheme: PinTheme): boolean {
  return pinTheme.id === DEFAULT_PIN_THEME_ID;
}
